"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ThresholdCondition_1 = __importDefault(require("./ThresholdCondition"));
class Threshold {
    constructor(threshold, conditions) {
        this.threshold = threshold;
        this.conditions = conditions;
    }
    static build(threshold) {
        return new Threshold(threshold.threshold, threshold.conditions.map((c) => ThresholdCondition_1.default.build(c)));
    }
}
exports.default = Threshold;
